module.exports = __webpack_public_path__ + "static/media/data_volume_icon.8ca3210e.svg";